import { css } from '@emotion/react';
import { Headers } from '@frontend/header';
import { Page } from '@frontend/page';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { CallHistoryHeader } from '../components/recent-calls/call-history-header';
import { RecentCallsTable } from '../components/recent-calls/recent-calls';

export const RecentCalls = () => {
  return (
    <>
      <Page css={styles}>
        <Page.Header>
          <Headers.Root
            css={css`
              padding: 0;
            `}
          >
            <Headers.RouterBreadcrumb />
            <Headers.TitleRow>
              <Headers.Title>
                <CallHistoryHeader />
              </Headers.Title>
            </Headers.TitleRow>
          </Headers.Root>
        </Page.Header>
        <Page.Body>
          <RecentCallsTable />
        </Page.Body>
      </Page>
    </>
  );
};

const styles = css`
  max-width: 100%;
  overflow: auto;
  height: 100%;

  @container main-content (max-width: ${breakpoints.xsmall.max}px) {
    padding: 0;

    .page-header {
      padding: ${theme.spacing(2, 2, 0, 2)};
      margin: 0;
    }
  }
`;
